import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  hideModalConfirmSaveAll,
  onClickSaveBank,
} from 'actions/setting/bankAccount';
import _ from 'lodash';
import styles from './ConfirmSaveAllModal.css';

class ConfirmSaveAllModal extends React.Component {
  _onClickCancel = e => {
    this.props.dispatch(hideModalConfirmSaveAll());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickSaveBank = () => {
    const { bankAccountForm } = this.props;
    let { outlets } = this.props;
    outlets = _.filter(outlets, outlet => {
      return !this._isHasBeenAssignedOtherBank(outlet.id);
    });
    bankAccountForm.outlets = outlets;
    this.props.dispatch(onClickSaveBank(bankAccountForm));
  };

  _isHasBeenAssignedOtherBank = outletId => {
    const { bankAccountDetail } = this.props;
    const outletStatus = _.find(this.props.outletStatus, ['id', outletId]);
    const findResult = outletStatus !== undefined;

    if (!bankAccountDetail) return findResult;
    return findResult && bankAccountDetail.bankAccId !== outletStatus.bankAccId;
  };

  render() {
    const { showModalConfirmSaveAll } = this.props;
    return (
      <Modal
        show={showModalConfirmSaveAll}
        dialogClassName={styles.modalDialog}
      >
        <Modal.Header bsClass={`modal-header ${styles.modalHeader}`}>
          Save to All Outlets
        </Modal.Header>
        <Modal.Body>
          Do you want this bank account to be assigned to all outlets <br />
          You cant deselect the outlet after you assigned & registered any
          payment method.
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-cancel']}`}
              type="button"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={this._onClickSaveBank}
            >
              Save
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    outlets,
    showModalConfirmSaveAll,
    outletStatus,
    bankAccountDetail,
  } = state.setting.bankAccount;
  return {
    bankAccountForm: getFormValues('bankAccount')(state),
    outlets,
    showModalConfirmSaveAll,
    outletStatus,
    bankAccountDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmSaveAllModal);
